<template>
    <div class="p-2">
        <div class="col row mt-2 dflex">
            <div class="col-12 dflex checkbox-wrapper">
                <input
                    :id="'chkEmphasized' + $vnode.key"
                    type="checkbox"
                    v-model="element.emphasized"
                />
                <label :for="'chkEmphasized' + $vnode.key">{{ $t("emphasized") }}</label>
            </div>
        </div>
        <div
            v-if="element.currentLang === key"
            class="col-12 dflex"
            :key="index2 + 1000000000 + forceReRenderKey"
            v-for="(key, index2) in Object.keys(element.label.dix)"
        >
            <div class="fit-content">
                <v-form-image-dix-cell
                    :element="element"
                    :image-dix="element.label.imageDix"
                />
            </div>
            <div class="col p-0">
                <input
                    :placeholder="
                        (key === 'Unknown' ? '' : key) + ' ' + $t('Website Url')
                    "
                    class="mb-1 form-text v-form-label form-text-dark ml-1"
                    type="text"
                    v-model="url"
                    @keydown="$v.url.$touch"
                />
                <div class="form-error ml-1" v-if="$v.url.$error">
                    {{ $t("errors.mustBeAValidURL") }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import vFormImageDixCell from "@/components/vForm/vFormImageDixCell";
import { vFormControls } from "@/enum";
import { url } from "vuelidate/lib/validators";

export default {
    name: "vFormWEBSITE",
    components: {
        vFormImageDixCell,
    },
    props: {
        element: { type: Object, required: true },
        stepNo: { type: Number, required: true },
    },
    data() {
        return {
            forceReRenderKey: 0,
            vFormControls: vFormControls,
            url: "",
        };
    },
    beforeMount() {
        this.element.formElementType = vFormControls["WEBSITE"];
    },
    watch: {
        url() {
            this.element.label.dix[this.element.currentLang] = this.url;
        },
    },
    validations: {
        url: {
            url,
        },
    },
    methods: {
    },
};
</script>

<style scoped></style>
